import { compact } from 'es-toolkit/compat';

import { serviceMap, type UntranslatedServiceItem } from '../data/serviceData';

export type AppResponse = {
    items: AppInfo[];
};

export type AppInfo = {
    id: string;
};

export const mapToServiceList = (appsResponse: AppResponse): UntranslatedServiceItem[] =>
    compact(
        appsResponse.items.flatMap((app: AppInfo): (UntranslatedServiceItem | null)[] => {
            // Both connection tiles inherit the existing API entry's permission and tenant checks.
            const serviceIds =
                app.id === 'customercenterPartnerConnections'
                    ? ['customercenterInboundConnections', 'customercenterOutboundConnections']
                    : [app.id];

            return serviceIds.map(id => {
                const service = serviceMap[id];
                return !service || service.hidden ? null : service;
            });
        })
    );
